import useData from './data-service'

export default function useWorldEvents(): string | undefined {
  const data = useData()
  if (!data) return undefined
  return data?.historicEvents
}
